import { PATH } from '../path';
import { selectThemeStyle, useAppSelector } from '@/app/store';
import { useScreenWidth } from '@/shared/hooks';
import { ChainThemeStyle } from '@/app/store/api/restApi';
import { Routes, Route, useLocation, matchPath, Location } from 'react-router-dom';
import { BasketPage, CatalogPage, ProductPage, ProductModal } from '../pages';

export const PageOrModalRoutes = () => {
  const location = useLocation();
  const { isDesktop } = useScreenWidth();
  const state = location.state as { backgroundLocation?: Location } | null;
  const designType = useAppSelector(selectThemeStyle);
  const minimalistic = designType === ChainThemeStyle.Minimalism;

  // A product opened from a card click carries the catalog/basket it was opened
  // from as `backgroundLocation`. On desktop a product reached by a direct link
  // (refresh, shared URL — no background captured) must still open as a modal
  // over the catalog, so synthesize a catalog background for that case.
  // The minimalistic theme always opens the product as a full page, never a modal.
  const isProductRoute = Boolean(matchPath(PATH.product, location.pathname));
  const backgroundLocation = minimalistic
    ? undefined
    : (state?.backgroundLocation ??
      (isDesktop && isProductRoute ? { ...location, pathname: PATH.catalog } : undefined));

  return (
    <>
      <Routes location={backgroundLocation || location}>
        <Route path={PATH.catalog} element={<CatalogPage />} />
        <Route path={PATH.basket} element={<BasketPage />} />
        <Route path={PATH.product} element={<ProductPage />} />
      </Routes>

      {backgroundLocation && (
        <Routes>
          <Route path={PATH.product} element={<ProductModal />} />
        </Routes>
      )}
    </>
  );
};
